import { inject } from '@angular/core'
import { CanActivateFn, RedirectCommand, Router } from '@angular/router'

import { HelperService } from '../../../shared/services/helper.service'

export const authGuard: CanActivateFn = async () => {
	const router = inject(Router)
	const helperService = inject(HelperService)
	const token = helperService.getUserData()?.access_token

	if (token) {
		return true
	}

	helperService.clearUserData()
	return new RedirectCommand(router.parseUrl('login'), {
		replaceUrl: false,
		skipLocationChange: true,
		onSameUrlNavigation: 'ignore',
		info: { fromAuthGuard: router.getCurrentNavigation()?.initialUrl?.root?.children['primary']?.segments },
	})
}
